import request from '@/utils/request'
import Cookies from 'js-cookie'

export function getList (filters = {}, pagination = {}) {
    const is_show_closed_protocol = parseInt(Cookies.get('is_show_closed_protocol'))
  
  return request({
    url: `/list/pregnancy/${is_show_closed_protocol}`,
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/pregnancy/' + id,
    method: 'get'
  })
}

export function remove (id) {
  return request({
    url: '/pregnancy/' + id,
    method: 'delete',
  })
}

export function nextCin (data) {
  return request({
    url: '/next_cin/pregnancy',
    method: 'post',
    data,
  })
}

export function meddra (term) {
  return request({
    url: '/meddra/' + term,
  })
}

export function notifyPregnancy (data) {
  return request({
    url: '/notify/pregnancy/' + data.id,
    method: 'post',
    data
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/pregnancy'
  if (data.id) {
    method = 'put'
    url = '/pregnancy/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function uploadPdf (data) {
  return request({
    url: '/pdf/pregnancy/' + data.get('id'),
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function removePdf (id) {
  return request({
    url: '/remove_pdf/pregnancy/' + id,
    method: 'post'
  })
}

export function downloadPdf (id, type, filename, download = true) {
  //issue vari
  var urlsite = '/pdf/pregnancy/' + id;
  if (download)
  {
    urlsite = "/download" + urlsite;
  }
  //issue vari
  return request({
    //issue vari
    url: urlsite,
    //issue vari
    method: 'get',
    responseType: 'blob',
  }).then( response => {
    var newBlob = new Blob([response.data], {type: "application/pdf"});
    var fileURL = window.URL.createObjectURL(newBlob, { oneTimeOnly: true });
    
    if(download) {
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    }

    return fileURL
  })
}

export function exportExcel (filters, filename) {
  return request({
    url: '/export/pregnancy',
    method: 'get',
    responseType: 'blob',
    headers: {
      // 'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  }).then( response => {
    var fileURL = window.URL.createObjectURL(new Blob([response]));
    var fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', filename);
    document.body.appendChild(fileLink);
    fileLink.click();
  })
}

export function getSeriousCriterias () {
  return ['Death', 'Life Threatening', 'Hospitalization required or prolonged', 'Congenital anomaly or Birth Defect', 'Other Medically Important Event']
}
